import React from "react";
import "./styles.less";

const Button = props => (
  <button
    type={props.type}
    className={`button 
					${props.primary ? "primary" : ""} 
					${props.accent ? "accent" : ""} 
					${props.disabled ? "disabled" : ""} 
					${props.large ? "large" : ""}`}
    onClick={props.disabled ? null : props.onClick}
  >
    {props.img ? <img src={props.img} /> : null}
    <div>{props.label ? props.label : props.children}</div>
  </button>
);

export default Button;



// WEBPACK FOOTER //
// ./components/Controls/Button.js